import $ from 'jquery'
import Splide from '@splidejs/splide'

// 各動画のロードを行う（iOSでは動画が自動ロードされないため明示的にロードさせる）
function loadVideo() {
  document.querySelectorAll('.js-mv-video').forEach((video) => {
    video.load()
  })
}

// Sliderを初期化
function initSlider(target) {
  const $firstSlide = $(target).find('.splide__slide:first-of-type')
  const options = {
    mediaQuery: 'min',
    perPage: 1,
    perMove: 1,
    gap: 0,
    type: 'fade',
    rewind: true,
    autoplay: 'pause',
    interval: $firstSlide.attr('data-splide-interval') || 4000,
    speed: 2400,
    drag: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    pagination: false,
    arrows: false,
    breakpoints: {
      768: {
        drag: false,
      },
    },
  }

  const slider = new Splide(target, options)
  slider.mount()

  return slider
}

// スライド切り替え時の動作を設定
// 切替時に動画を再生・停止する
function setSlideChangeActions(slider) {
  slider.on('move', (newIndex) => {
    const slide = slider.Components.Slides.getAt(newIndex).slide
    const video = slide.querySelector('video')
    if (video) {
      video.currentTime = 0
      video.play()
    }
  })

  slider.on('moved', (_, prevIndex) => {
    const slide = slider.Components.Slides.getAt(prevIndex).slide
    const video = slide.querySelector('video')
    if (video) {
      video.pause()
    }
  })
}

// 最大ローディング時間が経過したらresolveするPromiseを作成
function createMaxLoadingTimePromise() {
  return new Promise((resolve) => setTimeout(resolve, 3000))
}

// 画像の読み込みが完了したらresolveするPromiseを作成
function createImgLoadPromise(firstSlideMedia) {
  return new Promise((resolve) => {
    firstSlideMedia.addEventListener('load', () => {
      resolve()
    })
  })
}

// videoのcanplaythroughイベントが発生したらresolveするPromiseを作成
function createVideoCanPlayPromise(firstSlideMedia) {
  return new Promise((resolve) =>
    firstSlideMedia.addEventListener('canplaythrough', () => {
      resolve()
    })
  )
}

// videoが十分に再生可能ならresolveするPromiseを作成
function createVideoReadyStatePromise(firstSlideMedia) {
  return new Promise((resolve) => {
    if (firstSlideMedia.readyState >= 4) {
      resolve('readystate')
    }
  })
}

// OPの開始条件を満たしているかチェック
function checkStartCondition(promises, slider) {
  Promise.any(promises).then(() => {
    setTimeout(() => {
      startSlider(slider)
    }, 500)
  })
}

// OPを開始
function startSlider(slider) {
  $('.js-mv-loading')
    .addClass('is-loaded')
    .on('transitionend', () => {
      $('.js-mv-loading').hide()
    })

  slider.Components.Autoplay.play()
}

function init() {
  loadVideo()
}

function ready() {
  const target = document.querySelector('.js-mv-slider .splide')
  const firstSlideMedia = $('.js-mv-media').get(0)
  if (!target) return

  const slider = initSlider(target)
  setSlideChangeActions(slider)

  const isFirstSlideVideo = firstSlideMedia.tagName === 'VIDEO'

  const maxLoadingTimePromise = createMaxLoadingTimePromise()
  const imgLoadPromise = createImgLoadPromise(firstSlideMedia)
  const videoCanPlayPromise = createVideoCanPlayPromise(firstSlideMedia)
  const videoReadyStatePromise = createVideoReadyStatePromise(firstSlideMedia)

  const promises = isFirstSlideVideo
    ? [maxLoadingTimePromise, videoCanPlayPromise, videoReadyStatePromise]
    : [maxLoadingTimePromise, imgLoadPromise]

  checkStartCondition(promises, slider)
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
